<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container grid-list-md>
    <insufficient-credit-dialog/>
    <v-layout justify-center align-center>
      <v-flex :class="{ md10: standalone, md12: !standalone }">
        <v-card>
          <card-toolbar title="Tekil Numaraya Whatsapp Mesajı Gönder"></card-toolbar>
          <div style="padding: 15px;" v-if="!whatsappStatus">
            <v-alert type="warning">Whatsapp numaranız aktif değil. <a href="/whatsapp/settings" style="color:#fff">Buraya</a> tıklayarak veya Ayarlar sayfasına giderek numaranızı aktive edebilirsiniz.</v-alert>
          </div>
          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                      v-model="sendData.numbers"
                      v-mask="'0(###) ### ## ##'"
                      :rules="[$rules.empty('Telefon Numarası')]"
                      @input="sendData.numbers = $mask.unmasked(sendData.numbers)"
                      label="Alıcı Telefon Numarası"
                      required
                  >
                  </v-text-field>
                  <!-- Telefon Numarası -->
                  <senders
                      label="Whatsapp Telefon Numarası"
                      required
                      no-data-text="Whatsapp Telefon Numarası bulunmuyor"
                      :default="senders[0]"
                      :rules="[
                            $rules.required({
                              falseValues: [null],
                              message: 'Gönderici adı seçimi yapmalısınız',
                            }),
                          ]"
                      :items="data.senders"
                      @on:model-update="
                      (val) => {
                        sendData.sender = val;
                      }
                    "
                  >
                  </senders>
                  <!-- Whatsapp Telefon Numarası -->
                  <!-- Tür -->
                  <template-selector
                      ref="template"
                      label="Şablon Seçinizi"
                      :items="data.templates"
                      @on:template-selected="
                      (val) => {
                        msgBox = val.content;
                      }
                    "
                  >
                  </template-selector>
                  <!-- Şablon Seçinizi -->

                  <v-select
                      v-model="delay"
                      :items="delayOptions"
                      label="Gönderim Hızı"
                      :rules="[() => !!delay || 'Gönderim Hızı seçilmelidir.']"

                      required
                  ></v-select>
                  <v-file-input
                      label="Whatsapp mesajına dosya ekleyebilirsiniz."
                      placeholder="Whatsapp mesajına eklemek istediğiniz dosyayı seçiniz."
                      v-model="attachment"
                      prepend-icon=""
                      validate-on-blur
                      @change="handleAttachmentChange"
                  >
                  </v-file-input>
                  <img :src="previewUrl" alt="Preview" v-if="isImage" style="max-width: 10%;" />
                </v-col>
                <v-col cols="8">
                  <button-keys
                      :keys="data.keys"
                      item-value="value"
                      @on:button-key="
                      (val) => {
                        this.msgBox += ` ${val}`;
                      }
                    "
                  >
                  </button-keys>
                  <whatsapp-message
                      label="Mesajınızı bu alana giriniz"
                      required
                      :rows="13"
                      :rules="[
                            $rules.empty('Mesaj'),
                            (v) =>{
                              return v.length + messageHolder.length >= 2000 ? 'Maksimum karakter sayısı 2000 olabilir.' : true
                              }
                          ]"
                      :value="msgBox"
                      :cMessage="msgBox + messageHolder"
                      @button:status="(val) => buttonStatus = val"
                      @text:change="
                      (val) => {
                        msgBox = val;
                      }
                    "
                  >
                  </whatsapp-message>

                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <whatsapp-confirmation
                      :context="confirmation.context"
                      :valid="confirmation.valid"
                      @on:disagree="
                      () => {
                        $trigger('setPluginDialog');
                        confirmation.valid = !confirmation.valid;
                      }
                    "
                      @on:agree="
                      () => {
                        sendMessage();
                      }
                    "
                  >
                    <template v-slot:activator>
                      <v-btn color="primary" block @click="whatsappPreview" :disabled="buttonStatus === 'disabled' || !whatsappStatus ? true : false">
                        Mesajı Gönder
                        <v-icon right dark>mdi-send</v-icon>
                      </v-btn>
                    </template>
                  </whatsapp-confirmation>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import { types } from '../../../misc';
import Senders from '../../Components/WhatsappConstants/Senders.vue';
import TemplateSelector from '../../Components/WhatsappConstants/TemplateSelector.vue';
import WhatsappMessage from '../../Components/WhatsappConstants/WhatsappMessage.vue';
import CardToolbar from '../../Components/CardToolbar.vue';
import ButtonKeys from '../../Components/WhatsappConstants/ButtonKeys.vue';
import WhatsappConfirmation from '../../Components/WhatsappConfirmation.vue';
import InsufficientCreditDialog from '../../Components/InsufficientCreditDialog.vue';
import checkWebsite from '@/mixins/computed/check-website';

export default {
  name: 'Number',
  components: {
    WhatsappConfirmation,
    ButtonKeys,
    CardToolbar,
    WhatsappMessage,
    TemplateSelector,
    Senders,
    InsufficientCreditDialog,
  },
  mixins: [checkWebsite],
  props: {
    standalone: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    whatsappStatus: true,
    types,
    dateSelected: false,
    data: {},
    delayOptions: [
    { text: 'Çok Hızlı (5 saniye de bir)', value: 1 },
      { text: 'Hızlı (10 saniye de bir)', value: 2 },
      { text: 'Orta (20 saniye de bir)', value: 3 },
      { text: 'Yavaş (35 saniye de bir)', value: 4 },
    ],
    delay: null,
    attachment: [],
    previewUrl: null,
    attachmentName: null,
    isImage: false,
    confirmation: {
      valid: false,
      context: {
        examples: [],
      },
    },
    sendData: {},
    message: '',
    senders: [],
    defaultMessage: '',
    defaultLink: '/v/f58d59',
    messageHolder: '',
    buttonStatus: '',
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    prepareSendData() {
      this.sendData.message = this.msgBox;
      this.sendData.attachment = this.attachment.name;
      this.sendData.delay = this.delay;
      this.sendData.send_time = this.date + this.time;
      this.sendData.numbers = this.sendData.numbers.substr(
          this.sendData.numbers.length - 10
      );
      this.sendData.message_content_type = this.message_content_type;

      if (this.read) {
        this.sendData.read_message = this.readMessage;
        this.sendData.read_message_holder = this.messageHolder;
      }

      if (!this.wTimeStat) {
        delete this.sendData.send_time;
      }
    },
    handleAttachmentChange() {
      const file = this.attachment;

      if (file) {
        this.isImage = file.type.startsWith('image/');
        this.previewUrl = this.isImage ? URL.createObjectURL(file) : null;
        this.fileName = file.name;
      } else {
        this.previewUrl = null;
        this.fileName = null;
        this.isImage = false;
      }
    },
    prepareOriginal() {
      const form = new FormData();
      form.append('numbers', this.sendData.numbers.substr(this.sendData.numbers.length - 10));
      form.append('sender', this.sendData.sender);
      form.append('message', this.msgBox);
      form.append('attachment', this.attachment);
      form.append('delay', this.delay);
      return form;
    },
    resetForm() {
      this.$refs.form.reset();
      this.setValues();
    },

    sendMessage() {
      if (this.$refs.form.validate()) {
        this.send({
          route: 'whatsapp/number/send',
          data: this.prepareOriginal(),
          headers: { 'Content-Type': 'multipart/form-data' },
          method: 'POST',
        }).then(() => {
          this.resetForm();
        });
        this.$refs.template.clearOriginal();
        this.sendData.numbers = null;
        this.msgBox = null;
      }
    },
    whatsappPreview() {
      const messageContentLength = this.$trigger('get:count');
      if (
          (messageContentLength > 2000)
      ) {
        this.confirmation.valid = false;
      }

      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.prepareSendData();
        const data = {
          ...this.sendData,
        };

        this.send({
          route: 'whatsapp/number/send/preview',
          data,
        }).then((res) => {
          this.confirmation.context = res.data.data;
        });
      }
    },
  },
  created() {
    this.defaultLink = (this.isVatan
            ? 'vatansms.net'
            : 'toplusmspaketleri.com') + this.defaultLink;
    this.sendData.bridge = this.isVatan
        ? 'vatansms.net'
        : 'toplusmspaketleri.com';
    this.delay = this.delayOptions.find(option => option.text === "Çok Hızlı (5 saniye de bir)").value;

    const allowedKeys = [];
    this.sendData.numbers = this.$mask.unmasked(this.$route.params.phone);

    this.send({ route: 'whatsapp/number' }).then(async (res) => {
      this.data = await res.data.data;
      this.senders = res.data.data.senders;
      // eslint-disable-next-line prefer-destructuring
      this.sendData.sender = this.senders[0];
      this.data.keys = Object.filterByKey(allowedKeys, this.data.keys);
    });
    Vue.axios({
      url: `${this.$store.getters.apiEndpoint}whatsapp/check-device-active`,
      data: {},
      method: 'POST',
      statusCode: 500,
      responseType: 'JSON',
    }).then((res) => {
      this.whatsappStatus = res.data.data.device || res.data.data.other_devices && res.data.data.account_status;
    });
  },
  computed: {
    msgBox: {
      get() {
        return this.message || '';
      },
      set(newVal) {
        this.message = newVal;
      },
    },
    isDisabled: {
      get() {
        return this.$store.getters.getDisableSendWhatsappButton;
      },
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (from !== undefined && to.fullPath !== from.fullPath) {
          location.reload();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
